import React from 'react';
import '../styles/sonstige/kontakt.css';
import media from '../util/img_loader.js';

function Kontakt() {
    return (
        <section className="kontakt-section">
            <div className="kontakt-container">
                <div className="kontakt-text">
                    <h2>Kundenservice</h2>
                    <p><strong>Sie können gerne Kontakt mit uns aufnehmen oder uns Ihre Wünsche mitteilen!</strong></p>

                    <a href="/send-text" className="mail-button">
                        ✏️ Schreiben Sie uns
                    </a>

                    <hr className="divider" />

                    <div className="kontakt-info">
                        <div className="column">
                            <h3>Kontakt</h3>
                            <div className="info-line"></div>
                            <div className="info-line">info@nurleder.de</div>
                            <div className="info-line">📱 Mobil: +49 151 6155 9999</div>
                            <div className="info-line">Whats App: +49 151 6155 9999</div>
                            <div className="info-line">
                                ✉️ E-Mail: <a href="mailto:info@nurleder.de">info@nurleder.de</a>
                            </div>
                        </div>



                        <div className="column logo-column">
                            <img src={media['logo/Logo_nurleder.png']} alt="NurLeder Logo" />
                        </div>
                    </div>


                </div>
            </div>
        </section>
    );
}

export default Kontakt;
